var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [(_vm.showReuploadpod == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter AWB No"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchTrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.Statuslist,
      "placeholder": "Select Status",
      "append-to-body": true,
      "name": "status"
    },
    on: {
      "select": _vm.selectStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.zonelist,
      "placeholder": "Select Zone",
      "id": "zone",
      "append-to-body": true,
      "name": "zonename"
    },
    on: {
      "select": _vm.selectZone
    },
    model: {
      value: (_vm.zone),
      callback: function($$v) {
        _vm.zone = $$v
      },
      expression: "zone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("POD Review Date range ")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o' style='font-size: 12px'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "podUploadDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.podUploadDate),
      callback: function($$v) {
        _vm.podUploadDate = $$v
      },
      expression: "podUploadDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "48rem"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchPODDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t  "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n\t\t\t\t\t  ")])])], 1)])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" POD's List\n\t\t\t  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "float": "right",
      "padding-top": "5px"
    }
  }, [_vm._v("Total Records:" + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px"
    },
    attrs: {
      "type": "button",
      "title": "Download (XLSX) - Last 30 days data download without filter"
    },
    on: {
      "click": function($event) {
        _vm.DownloadRequestedData()
      }
    }
  }, [_vm._v("\n\t\t\t\tDownload (XLSX)\n\t\t\t  ")])])]), _vm._v(" "), _c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "offset": _vm.offset,
      "isViewImage": true,
      "isViewHidden": true,
      "isReuploadImage": true,
      "isEditHidden": true,
      "id": "reuploadimage"
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "data-toggle": "modal"
    },
    on: {
      "ok": function($event) {
        _vm.reUploadPodModal = false
      }
    },
    model: {
      value: (_vm.reUploadPodModal),
      callback: function($$v) {
        _vm.reUploadPodModal = $$v
      },
      expression: "reUploadPodModal"
    }
  }, [_c('b-card', {
    staticClass: "overflow-hidden"
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("\n\t\t   Upload POD\n\t\t   "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeReuploadPOD
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-bottom": "1.6rem"
    }
  }, [_c('div', {
    staticClass: "col-md-3 "
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UploadType),
      expression: "UploadType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "uploadpod",
      "value": "1",
      "name": "UploadType"
    },
    domProps: {
      "checked": _vm._q(_vm.UploadType, "1")
    },
    on: {
      "click": function($event) {
        _vm.uploadpod($event)
      },
      "__c": function($event) {
        _vm.UploadType = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "UploadPod"
    }
  }, [_vm._v("Upload POD ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 "
  }, [_c('input', {
    ref: "file",
    staticClass: "uploadpodimage",
    attrs: {
      "multiple": "true",
      "type": "file",
      "accept": ".jpeg,.jpg,.png",
      "id": "files",
      "name": "Image",
      "disabled": _vm.disableuplaodpod
    },
    on: {
      "change": function($event) {
        _vm.FileUpload($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 "
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UploadType),
      expression: "UploadType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "podnotavailable",
      "value": "0",
      "name": "UploadType"
    },
    domProps: {
      "checked": _vm._q(_vm.UploadType, "0")
    },
    on: {
      "click": function($event) {
        _vm.uploadpod($event)
      },
      "__c": function($event) {
        _vm.UploadType = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "notAvailable"
    }
  }, [_vm._v("Not Available ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.badpodreasons,
      "placeholder": "Select Reason",
      "append-to-body": true,
      "disabled": _vm.disablereason,
      "name": "badpodreason"
    },
    on: {
      "select": _vm.selectPODReason
    },
    model: {
      value: (_vm.badpodreason),
      callback: function($$v) {
        _vm.badpodreason = $$v
      },
      expression: "badpodreason"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.handleFileUpload()
      }
    }
  }, [_vm._v(" SUBMIT "), _c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetReupload
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "data-toggle": "modal"
    },
    on: {
      "ok": function($event) {
        _vm.PreviousPodImages = false
      }
    },
    model: {
      value: (_vm.PreviousPodImages),
      callback: function($$v) {
        _vm.PreviousPodImages = $$v
      },
      expression: "PreviousPodImages"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("POD Images ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePreviousPodImages
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Previous POD Images\n\t\t\t\t\t\t"), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("(Click on the image to view it)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.podimagearray), function(item) {
    return _c('div', {
      staticClass: "col-md-5"
    }, [_c('br'), _vm._v(" "), (item) ? _c('img', {
      staticStyle: {
        "cursor": "pointer",
        "width": "65px",
        "margin-left": "9rem",
        "height": "65px"
      },
      attrs: {
        "src": item,
        "alt": "NO Image",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item) ? _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "1rem",
        "margin-left": "20px",
        "margin-right": "10px",
        "margin-top": "1rem"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Image"
      },
      on: {
        "click": function($event) {
          _vm.fileview(item)
        }
      }
    }) : _vm._e()])
  }))])])])], 1), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.image
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.image)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.caption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.image,
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be5fd4a","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/POD/reuploadpod/pod.component.html
// module id = 1945
// module chunks = 3